'use client';

import { useEffect } from 'react';
import { markModuleViewed } from '@/lib/storage/moduleProgress';

interface ModuleProgressTrackerProps {
  moduleId: string;
}

/**
 * Client component to track module views
 * Automatically marks module as viewed when component mounts
 */
export function ModuleProgressTracker({ moduleId }: ModuleProgressTrackerProps) {
  useEffect(() => {
    markModuleViewed(moduleId).catch((error) => {
      console.error('Failed to track module view:', error);
    });
  }, [moduleId]);

  return null; // This component doesn't render anything
}
